<template>
  <wsp-modal>
    <v-form ref="form"
            v-model="valid"
            v-on:submit.prevent="()=> {return false}">
      <v-card class="pb-5">
        <v-card-title class="pa-0">
          <v-toolbar class="primary"
                     dark
                     dense
                     flat>
            <v-toolbar-title>
              {{ $t('teletag.editTeletag.title')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon
                   @click="visible = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>

        <v-card-text>
          <v-layout row
                    wrap>
            <v-flex xs12
                    sm12
                    class="px-2">
              <v-text-field :label="$t('global.placeholder.plate')"
                            v-model="form.plate"
                            :rules='plateRules'
                            name="plate"
                            type="text"
                            required>
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat
                 round
                 color="primary"
                 class="capitalize"
                 @click="visible = false">
            {{$t('global.button.cancel')}}
          </v-btn>
          <v-btn :disabled='!valid'
                 :loading="isLoading"
                 type="submit"
                 color="accent"
                 class="capitalize white--text mr-4"
                 @click="submit"
                 round
                 outline>
            {{$t('global.button.send')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import teletagService from '@/services/teletagService';
import manageErrorService from '@/services/manageErrorService';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';

export default {
  name: 'EditTeletag',
  components: {
    [WspModal.name]: WspModal
  },
  watch: {
    visible: function(value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    }
  },
  props: {
    teletag: {
      type: Object,
      required: true
    }
  },
  computed: {
    plateRules() {
      return [
        v => !!v || this.$i18n.t('global.validation.required.text'),
        v => !(/[^A-Za-z0-9]+$/.test(v)) || this.$i18n.t('global.validation.plate.format')
      ]
    }
  },
  data() {
    return {
      visible: true,
      isLoading: false,
      valid: false,
      form: {
        plate: ''
      }
    };
  },
  created() {
    this.form.plate = this.teletag.plate
  },
  methods: {
    async submit() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }

      this.isLoading = true;

      let form = {
        code: this.teletag.code
      }

      if (this.form.plate) {
        form.plate = this.form.plate.replace(/\s/g, '')
      }

      let results = await teletagService.changePlate(form);

      if (results.error) {
        manageErrorService.handle(results.data);
        this.isLoading = false
        this.valid = true
        return;
      }

      this.visible = false
      this.$emit('on-success', {})

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('teletag.editTeletag.toast.success'),
        type: 'info',
        doNotTranslate: true
      });
    }
  }
};
</script>
